import { render, staticRenderFns } from "./ToggleButton.vue?vue&type=template&id=19c93c42"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"
import style0 from "./ToggleButton.vue?vue&type=style&index=0&id=19c93c42&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports